import React, { Component } from 'react'

import { Button, Menu, Modal } from 'antd'

import { UIAvatarLabel, UIPageListing } from '../../../components'

import { equipmentsService } from '../../../redux/services'

const config = {
  searchPlaceholder: 'Buscar funcionário',
  permissionPrefix: 'customers',
}

class Index extends Component {
  constructor(props) {
    super(props)

    this.state = {
      listType: 'list',
      isLoading: false,
      dataAll: [],
      data: [],
      search: '',
      // Owner item
      ownerItem: {},
      // Selection
      selectedItems: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
    }
  }

  init = (ownerItem) => {
    this.setState({
      ownerItem: ownerItem,
      selectedItems: [],
    }, () => {
      this.fetchGetAll(true)
    })
  }

  menuItem = (item) => (
    <Menu className="actions-dropdown-menu"></Menu>
  )

  onSelectItem = (item, checked) => {
    this.setState((state) => ({
      selectedItems: checked
        ? [...state.selectedItems, item.id]
        : state.selectedItems.filter((id) => id !== item.id),
    }))
  }

  clearSelection = () => {
    this.setState({ selectedItems: [] })
  }

  columns = () => [
    {
      title: 'Funcionário',
      render: (item) => <UIAvatarLabel id={item?.id} name={item?.nome} avatar={item?.avatar} />,
    },
    {
      title: 'Departamento',
      render: (item) => item?.contrato[0]?.departamento?.nome ?? '-',
    },
    {
      title: 'Função',
      render: (item) => item?.contrato[0]?.funcoes?.nome ?? '-',
    },
    {
      title: 'Status',
      className: 'active no-ellipsis',
      width: 100,
      render: (item) => (
        <span className={`status-tag ${item.ativo == 1 ? 'status-tag-success' : 'status-tag-error'}`}>
          <i className="status-tag-dot" />
          {item.ativo == 1 ? 'Ativo' : 'Inativo'}
        </span>
      ),
    },
  ]

  fetchGetAll = (init = false) => {
    const { pagination, ownerItem } = this.state

    this.setState({
      isLoading: true,
    })

    const data = {
      nome: this.state.search,
      equipamento_id: ownerItem.uuid,
      page: init ? 1 : pagination.current,
      limit: pagination.pageSize,
    }

    equipmentsService
      .getEmployeesEquipment(data)
      .then((response) => {
        this.setState((state) => ({
          isLoading: false,
          data: response.data.data,
          dataAll: response.data.data,
          pagination: {
            ...state.pagination,
            current: response.data.meta.current_page,
            total: response.data.meta.total,
          },
        }))
      })
      .catch((data) => {
        this.setState({
          isLoading: false,
        })

        Modal.error({
          title: 'Ocorreu um erro!',
          content: String(data),
        })
      })
  }

  onPaginationChange = (page, pageSize) => {
    this.setState(
      (state) => ({
        pagination: {
          ...state.pagination,
          current: page,
          pageSize,
        },
      }),
      () => {
        this.fetchGetAll()
      }
    )
  }

  searchItems = () => {
    const { search } = this.state
    const newData = [...this.state.dataAll]

    this.setState({
      data: search
        ? newData.filter(
            (item) =>
              item?.nome.toLowerCase().indexOf(search.toLowerCase()) !== -1 ||
              item?.nome.toLowerCase().indexOf(search.toLowerCase()) !== -1
          )
        : newData,
    })
  }

  onSearch = (value) => {
    this.setState(
      {
        search: value,
      },
      () => {
        this.fetchGetAll(true)
      }
    )
  }

  onSearchChange = (e) => {
    // If it does not have type then it's cleaning
    if (!e.hasOwnProperty('type')) {
      const { search } = this.state

      this.setState(
        {
          search: e.target.value,
        },
        () => {
          if (search) {
            this.searchItems()
          }
        }
      )
    }
  }

  render() {
    const { readOnly } = this.props
    const { data, isLoading, search, selectedItems, pagination } = this.state
    const hasSelection = !readOnly && selectedItems.length > 0

    return (
      <UIPageListing
        icon={<i className="fal fa-users" />}
        title="Funcionários"
        subtitle={readOnly ? undefined : 'Selecione os funcionários que terão acesso a este equipamento.'}
        hideHeaderOnSelect={false}
        allowSelect={!readOnly}
        selectedItems={selectedItems}
        onSelectItem={this.onSelectItem}
        onSearch={this.onSearch}
        onSearchChange={this.onSearchChange}
        listType={this.state.listType}
        search={search}
        searchPlaceholder={config.searchPlaceholder}
        showListTypeChange={false}
        isLoading={isLoading}
        data={data}
        columns={this.columns()}
        pagination={pagination}
        onPaginationChange={this.onPaginationChange}
        actions={hasSelection && (
          <div className="stat-counter stat-counter-with-action">
            <div className="stat-counter-icon">
              <i className="fal fa-users" />
            </div>
            <div>
              <p className="stat-counter-value">{selectedItems.length}</p>
              <p className="stat-counter-label">
                <strong>funcionários</strong>
                selecionados
              </p>
            </div>
            <Button className="action-btn-secondary stat-counter-action" icon={<i className="fal fa-trash-alt" />} onClick={this.clearSelection}>
              Limpar seleção
            </Button>
          </div>
        )}
        infoBanner={{
          icon: <i className="fal fa-info-circle" />,
          title: 'Sobre os funcionários',
          description: 'Apenas funcionários ativos podem ser atribuídos ao equipamento.',
        }}
      />
    )
  }
}

export default Index
